import { FC, memo, useContext, useMemo } from 'react';
import { ScAuroraPanel } from './styled';

import menuBg from 'assets/images/crystal/menu-bg.webp';
import diamond1 from 'assets/images/crystal/diamond-1.webp';
import diamond2 from 'assets/images/crystal/diamond-2.webp';
import { useAuroraCrystalLogic } from 'modules/crystal/hooks';
import { useTheme } from 'hooks/theme';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'react-navi';
import { AuthContext } from '@repo-level/core-front';
import { ImageComponent } from 'components/Image';

export interface IAuroraPanelProps {
  onLinkClick?: () => void;
}

export const AuroraPanel: FC<IAuroraPanelProps> = memo(({ onLinkClick }) => {
  const { t } = useTranslation(['crystal']);

  const { isAuthenticated } = useContext(AuthContext);

  const { images } = useTheme();

  const { navigate } = useNavigation();

  const { spins } = useAuroraCrystalLogic();
  const { remains, total } = spins;

  const noSpins = remains === 0;

  const diamondSrc = noSpins ? diamond1 : diamond2;

  const message = useMemo(() => {
    if (!isAuthenticated) return t('crystal:nonAuthPanelTitle');
    if (noSpins) return t('crystal:noSpinsLeft', { total });
    return t('crystal:spinsLeft', { remains, total });
  }, [isAuthenticated, noSpins, total, remains, t]);

  return (
    <ScAuroraPanel
      onClick={() => {
        onLinkClick && onLinkClick();
        navigate('/lucky-wheel');
      }}
    >
      <ImageComponent fill className="bg" src={menuBg} alt="background" />
      <div className="inner">
        <div className="content">
          <ImageComponent
            width={38}
            height={24}
            className="crystal mobile"
            src={diamondSrc}
            alt="diamond"
          />
          <div className="content-text">
            <div className="title">
              <p>Aurora Crystals</p>
              <ImageComponent
                width={22}
                height={14}
                className="crystal desktop"
                src={diamondSrc}
                alt="diamond"
              />
            </div>
            <p className="spins-left">{message}</p>
          </div>
        </div>
        <div className="mobile">
          <images.arrowRightSmallIcon.component />
        </div>
      </div>
    </ScAuroraPanel>
  );
});
